import {
  TabCount,
  TabItem,
  TabsWrapper,
} from 'modules/Drive/Partials/DriveTabs/Style/style'
import React from 'react'
const AntdTabs = ({ tabs, selected, setSelected, onTabChange }) => {
  return (
    <TabsWrapper>
      {tabs.map(tab => (
        <TabItem
          key={tab.value}
          isActive={selected === tab.value}
          onClick={() => {
            setSelected(tab.value)
            onTabChange(tab)
          }}
        >
          {tab.label}
          <TabCount>{tab.count}</TabCount>
        </TabItem>
      ))}
    </TabsWrapper>
  )
}

export default AntdTabs
